import React from "react";

import {DishDetailsItem} from "@apps/dish/interfaces";

import {EventOrigin, recordEvent} from "@globals/config/eventUtils";
import {IMAGE_SIZES} from "@globals/functions/getResolutionImgUrl";
import {useUser} from "@globals/user";

import {DishDetailsConfigProvider} from "@components/DishDetails";
import {MenuRowSkeleton} from "@components/LoadingSkeleton";
import MenuItem from "@components/MenuItem";

import BrandHeader from "../BrandHeader";
import {Brand} from "../interfaces";
import getBrandDishesImageSize from "../utils/getBrandDishesImageSize";
import styles from "./BrandDishes.scss";

type BrandDishesProps = {
  brand: Brand;
  dishes?: DishDetailsItem[];
  isLoading?: boolean;
};

export default function BrandDishes({
  brand,
  dishes,
  isLoading = false,
}: BrandDishesProps): JSX.Element {
  const {isAuthorized} = useUser();

  const recordQuickViewOpen = () => {
    recordEvent(EventOrigin.PAGE, "open QV all dishes", brand.id);
  };

  return (
    <section className={styles.wrapper} aria-labelledby="brand-dishes-header">
      <BrandHeader id="brand-dishes-header">
        All dishes by {brand.name}
      </BrandHeader>
      {isLoading ? (
        <MenuRowSkeleton />
      ) : (
        <DishDetailsConfigProvider
          hideRating={!isAuthorized}
          showFavorites={isAuthorized}
          showReviews={isAuthorized}
          hidePrice
          hidePurchaseButton
          showFavoriteHoverBox
        >
          <div className={styles.dishes} role="list">
            {dishes!.map((dish) => (
              <div key={dish.id} className={styles.dishItemContainer}>
                <MenuItem
                  wrapperClassName={styles.dishItemWrapper}
                  item={dish}
                  imageSize={IMAGE_SIZES.DAILY_MENU}
                  sizesAttribute={getBrandDishesImageSize()}
                  onQuickViewOpen={recordQuickViewOpen}
                />
              </div>
            ))}
          </div>
        </DishDetailsConfigProvider>
      )}
    </section>
  );
}
